export default "__VITE_ASSET__BPKfolr3__"